import { render, staticRenderFns } from "./en_footer.vue?vue&type=template&id=424cca2f&scoped=true"
import script from "./en_footer.vue?vue&type=script&lang=js"
export * from "./en_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424cca2f",
  null
  
)

export default component.exports